import Vue from "vue";
import Router from "vue-router";
import SortableList from "./components/sortable-list/SortableList";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/page/ADMIN_OVERVIEW",
      name: "Employee overview",
      component: SortableList
    },
  ]
});

export default router;
